import { Component, Input } from '@angular/core';

import { DynamicHtmlDirective } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    imports: [DynamicHtmlDirective, IconCustomComponent],
    selector: 'lh-login-links',
    templateUrl: 'login-links.component.html',
})
export class LoginLinksComponent {
    @Input() highlightHints: boolean;
    @Input() text?: string;
}
